import React from 'react'
import { AssessRequirementsWorkflowMain } from './components/AssessmentWorkflowMain'
import { AssessRequirementsWorkflowProvider } from './context/AssessmentWorkflowProvider'

/** A workflow to assess multiple worker requirements per call */
export const AssessRequirementsWorkflow = () => {
  return (
    <AssessRequirementsWorkflowProvider>
      <AssessRequirementsWorkflowMain />
    </AssessRequirementsWorkflowProvider>
  )
}
